import * as moment from 'moment';
import Vue from 'vue';

export default {
  state: {
    issue: null,
    issues: {},
    issueDiscussions: {},
    discussionsCounter: null
    // userAvatar:
    //     document.getElementById('userAvatar').value,
  },
  mutations: {
    setIssue(state, payload) {
      state.issue = { ...payload };
    },
    setIssues(state, payload) {
      state.issues = { ...payload };
    },
    updateIssueListItemStatus(state, payload) {
      if (state.issues && state.issues.items) {
        // eslint-disable-next-line array-callback-return, consistent-return
        state.issues.items.find((item, key) => {
          if (item.localId === payload.id) {
            Vue.set(state.issues.items, key, {
              ...item,
              status: payload.status,
              updatedAt: moment(moment.now()).fromNow()
            });

            return true;
          }
        });
      }

      if (state.issue) {
        Vue.set(state, 'issue', {
          ...state.issue,
          status: payload.status,
          updatedAt: moment(moment.now()).fromNow()
        });
      }
    },
    setIssueDiscussions(state, payload) {
      state.issueDiscussions = { ...payload };
    },
    appendIssueDiscussions(state, payload) {
      state.issueDiscussions.page = payload.page;
      state.issueDiscussions.items = state.issueDiscussions.items.concat(payload.items);
    },
    appendIssueComment(state, payload) {
      state.issueDiscussions.items.push(payload);
    },
    setIssueDescription(state, payload) {
      if (state.issues && state.issues.items && state.issues.items.length) {
        // eslint-disable-next-line array-callback-return, consistent-return
        state.issues.items.find((item, key) => {
          if (item.localId === payload.issue.localId) {
            Vue.set(state.issues.items[key], 'description', payload.data.description);
            Vue.set(state.issues.items[key], 'descriptionHtml', payload.data.descriptionHtml);
            return true;
          }
        });
      }
    },
    addDiscussionsCounter(state, payload) {
      state.discussionsCounter = payload;
    }
  },
  actions: {
    setIssue(state, payload) {
      state.commit('setIssue', payload);
    },
    setIssues(state, payload) {
      state.commit('setIssues', payload);
    },
    updateIssue(state, payload) {
      state.commit('updateIssueStatus', payload);
    },
    setIssueDiscussions(state, payload) {
      state.commit('setIssueDiscussions', payload);
    },
    appendIssueDiscussions(state, payload) {
      state.commit('appendIssueDiscussions', payload);
    },
    appendIssueComment(state, payload) {
      state.commit('appendIssueComment', payload);
    },
    updateIssueListItemStatus(state, payload) {
      state.commit('updateIssueListItemStatus', payload);
    },
    setIssueDescription(state, payload) {
      state.commit('setIssueDescription', payload);
    },
    setDiscussionsCounter(state, payload) {
      state.commit('addDiscussionsCounter', payload);
    }
  },
  getters: {
    getIssues(state) {
      return state.issues;
    },
    getIssue(state) {
      return state.issue;
    },
    getIssueDiscussions(state) {
      return state.issueDiscussions;
    },
    getDiscussionsCounter(state) {
      return state.discussionsCounter;
    }
    // getUserAvatar(state) {
    //     return state.userAvatar;
    // }
  }
};
